import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { Observable } from 'rxjs';
import { UserTableComponent } from 'src/app/components/tables/user/user-table.component';
import { User } from 'src/app/models/user.model';
import { SideBarMenuService } from 'src/app/services/sidebar-menu.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'users',
  standalone: true,
  imports: [BreadcrumbModule, AsyncPipe, UserTableComponent],
  templateUrl: './users.component.html',
})
export class UsersComponent {
  users$: Observable<User[]>;
  home: MenuItem;
  breadcrumbItems: MenuItem[] = [];

  private userService = inject(UserService);
  private sidebarMenuService = inject(SideBarMenuService);

  ngOnInit(): void {
    this.home = {
      icon: 'pi pi-fw pi-mobile',
      routerLink: '/',
      command: () => this.sidebarMenuService.clearSessionStorage(),
    };
    this.breadcrumbItems = [{ label: 'Usuarios', styleClass: 'font-bold' }];
    this.users$ = this.userService.findUsers();
  }
}
